import { template } from 'underscore';
import EventsLoggingService from 'js/EventsLoggingService';
import layers from 'data/layers.json';
import { capitalizeUserName, nullornot } from 'client/utils/stringsFormatting';
import addressWindow from 'client/templates/addressWindow.html';
import initialWindowDev from 'client/templates/initialWindow.html';
import { getHandlerFor } from 'client/utils/angular';

const DEFAULT_PROPERTYINFO = { coords: null, gid: null, features: null, myp_municipality: null, location: null, myp_area_ha: null, geomextent: null, geomextent_width_m: null, geomextent_height_m: null };
const { EventTypes } = EventsLoggingService;

export default function ($scope, datorontoService, authenticationService, historyService, sidebarService, $location,
    $timeout, $interval, $rootScope, Maps, ngDialog, $routeParams, $route, $tooltip, $window,
    USER_ROLES, AUTH_EVENTS, googleMapsFactory) {

    $rootScope.address = "";
    $rootScope.comingSoon = false;
    $rootScope.reportFeature = false;
    $rootScope.report = { gid: "", lat: "", lng: "", lat2019: "", lng2019: "", lat4326: "", lng4326: "", location: "", myp_municipality: "", myp_area_ha: "", geomextent: "", geomextent_width_m: "", geomextent_height_m: "", zoom: "", username: "", lng2952: "", lat2952: "", department: "", company: "", system: "" };
    $scope.isZoom = false;

    $rootScope.isPropertySelected = false;//Check if there is a property currently clicked

    $scope.unlockOn = false;

    $rootScope.parcelLock = true;//Used for handling status of parcel click in dev app mode

    $scope.IEactive = false;

    $rootScope.hasProperty = false;//Regulates when the report button is shown and hidden.

    $scope.onSidebar = false;

    $scope.isAzureWarning = false;

    $scope.googlePlace = null;

    $scope.isLog = true;//Used to show the login nav bar when user isn't signed in.
    $scope.isUser = false;//Used to show the user nav bar when user is signed in.
    $scope.resetDialog = '';
    $scope.forgotDialog = '';
    $scope.sidebarData = "";
    $scope.loginVisible = false;
    $scope.waterTog = false;

    $scope.initProp = 0;//Value used to show first layer to user when they click their first property.
    $rootScope.initSidebar = false;//Used to determine if sidebar call needs to be made after first click by the cotnroller

    $scope.isSearchBar = false;
    $scope.myp_municipality = "";
    $scope.myp_area_ha = "";
    $scope.geomextent = "";
    $scope.geomextent_width_m = "";
    $scope.geomextent_height_m = "";

    $scope.environment = false;

    //Cookie emulator for tutorials
    $scope.tut1 = 0;
    $scope.tut2 = 0;

    //Dev App
    $rootScope.isDev = false;

    $scope.geoInterval = false;

    $scope.legendType = "";

    $scope.isHover = false;
    $scope.changeBar = {};
    $rootScope.mapLayers = {};//Used to make ImageMapType array for Google Map overlay
    $scope.canToggle = false;
    $scope.propClick = false;
    $scope.startSearch = false;
    $scope.sidebar = { gid: "", type: "", myp_municipality: "" };
    $scope.history = { url: "", address: "",  lat: "", lng: ""};//Holds url path and address of clicked property
    $scope.model = { address: "" };
    $scope.initSearch = false;
    $scope.legendClick = false;
    $scope.legendInfo = "";
    $scope.legendTitle = "";

    $rootScope.isAccess = false;

    //Set user roles and authorized status
    $scope.userRoles = USER_ROLES;

    //Root scope variable to hold user information
    $rootScope.currentUser = { "acc_type": USER_ROLES.GUEST };

    //Check if user is signed in already
    authenticationService.getUserCookie().then(function (data) {
        if (data.data.flash) {

        }
        else {
            if (data.data.length === undefined) {
                $rootScope.currentUser = data.data;
                $rootScope.currentUser.name = capitalizeUserName($rootScope.currentUser.name);
            } else {
                $rootScope.currentUser = data.data[0];
            }
            var res = $rootScope.currentUser.name.split(' ');
            $rootScope.username = res[0];
            $scope.isLog = false;
            $scope.isUser = true;

            //Perform cut off check
            $rootScope.$broadcast('cutoffCheck');

            //Perform redirect cookie check
            $rootScope.$broadcast('redirectCookie');
        }
    });

    $scope.launchPro = function () {
        authenticationService.getUser().then(function (response) {
            var userInfo = response.data;

            var USER_ROLES = [
                "BASIC",
                "TRIAL",
                "PRO",
                "PREM",
                "BETA",
                "ADMIN"
            ];

            var isAuthorized = USER_ROLES.includes(userInfo.acc_type);

            if (isAuthorized) {
                window.open('/pro', 'ProPlannerView');
            } else {
                ngDialog.open({
                    // templateUrl: 'templates/pro-experience-insufficient-permissions.tpl.html',
                    templateUrl: '/views/prime.html',
                    className: 'ngdialog-theme-plain',
                    controller: 'PrimeCtrl',
                    scope: $scope
                });
            }
        });
    };

    $scope.goBackToOldDesign = function () {
        // record on mixpanel event here...
        $window.location.href = `https://app.mapyourproperty.${window.location.host.split('.').pop()}/${window.location.hash}`
    }

    $scope.giveFeedback = function () {
        if ($window.HubSpotConversations) $window.HubSpotConversations.widget.open()
    }

    if ($location.search().data) {
        $location.search('data', null);
    }

    if ($rootScope.searchedPath != null) {
        $scope.model.address = $rootScope.searchedPath;
        $rootScope.searchedPath = null;
        $scope.startSearch = true;
        $scope.initSearch = true;
    }

    if ($location.search().address) {
        $scope.model.address = $location.search().address;
        $scope.initSearch = true;
    }

    //Enable or disable report function for user.
    authenticationService.isReportAuthenticated().success(function (data) {
        $rootScope.reportFeature = data;
    });

    //Grab info on users browser
    $rootScope.userAgent = $window.navigator.userAgent;
    if ($window.navigator.platform.indexOf("Win") > -1) {
        $rootScope.report.system = 'win';
    } else if ($window.navigator.platform.indexOf("Mac") > -1) {
        $rootScope.report.system = 'mac';
    }

    //Get the google maps opbject from the factory
    $scope.map = googleMapsFactory.loadMap();

    $scope.map.get('streetView')
        .setOptions({
            addressControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER
            },
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            }
        });

    $scope.allowedBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(44.223, -79.544),
        new google.maps.LatLng(43.583, -80.163)
    );

    $scope.addressWindow = new google.maps.InfoWindow;
    $scope.initialWindow = new google.maps.InfoWindow;

    //Icon used when property is clicked by users
    $scope.prop_icon = {
        url: "/img/red-pushpin.png"
    };

    $scope.marker = new google.maps.Marker({
        map: $scope.map,
        draggable: true,
        crossOnDrag: false,
        animation: google.maps.Animation.DROP
    });

    //Load Google map auto complete objects
    $scope.aOptions = Maps.get({ mapId: 'gm-auto-complete' });

    $scope.tooltip_legend = { title: 'Legend', checked: false };
    $scope.tooltip_op = { title: 'Official Plan', checked: false };
    $scope.tooltip_cw = { title: 'Municipal Plan', checked: false };
    $scope.tooltip_bl = { title: 'Zoning By-Law', checked: false };
    $scope.tooltip_water = { title: 'Water', checked: false };
    $scope.tooltip_environment = { title: 'Environment', checked: false };
    $scope.tooltip_pp = { title: 'Provincial Plan', checked: false };
    $scope.tooltip_dat = { title: 'Development Tracking', checked: false };

    $scope.tooltip_toggle = { title: 'Toggle Sidebar', checked: false };

    $scope.tooltip_proplanner = { title: 'Login to Access', checked: false };
    $scope.tooltip_login = { title: 'Login/Signup', checked: false };
    $scope.tooltip_reportDisable = { title: 'Please click a property!', checked: false };

    $scope.tooltip_proplanner_user = { title: 'Access for more layers', checked: false };
    $scope.tooltip_report_user = { title: 'Generate report for selected property', checked: false };
    $scope.tooltip_login_user = { title: 'Tutorial/Logout', checked: false };

    $scope.tooltip_contact = { title: 'Contact Us', checked: false };
    $scope.tooltip_comingSoon = { title: 'Coming Soon!', checked: false };

    $scope.tooltip_history = { title: 'History', checked: false };
    $scope.tooltip_upgrade = { title: 'Upgrade Now!', checked: false };
    $scope.tooltip_account = { title: 'Account Info', checked: false };

    $scope.overlay = new google.maps.OverlayView();
    $scope.overlay.draw = function () { };
    $scope.overlay.setMap($scope.map);
    $scope.triangleCoords = new google.maps.MVCArray();
    $scope.bermudaTriangle = new google.maps.Polygon();
    $scope.polyTriangle = new google.maps.Polygon();
    $scope.polygonOptions = null;
    $scope.coords = null;
    $scope.propertyInfo = DEFAULT_PROPERTYINFO; //Holds information for property that the user is interacting with
    $scope.mouseMoveOn = true;
    $scope.clickPolyOn = false;
    //Object used for Geo coding & reverse Geo coding user input
    $scope.geocoder = new google.maps.Geocoder();
    $rootScope.user_access = [];

    //Load sidebar buttons
    $scope.categories = Maps.query({ mapId: 'categories' });

    //Create ImageMapType for each layer in layers.json
    $scope.makeLayer = function (layer) {
        return new google.maps.ImageMapType({
            getTileUrl: function (coord, zoom) {
                $rootScope.layerLoaded = false;
                return $window.url_gs + "layers=" + layer.link + "&" + "zoom=" + zoom + "&x=" + coord.x + "&y=" + coord.y + "&format=" + layer.format;
            },
            tileSize: new google.maps.Size(layer.size, layer.size),
            isPng: layer.isPng,
            opacity: layer.opacity,
            name: layer.name,
            alt: layer.type
        });
    };

    layers.forEach((layer, index) => {
        if (layer.name == "dev-app-toronto") {
            $rootScope.mapLayers[index] = $scope.makeWMSLayer(layer, 'wms');
        } else {
            $rootScope.mapLayers[index] = $scope.makeLayer(layer);
        }
    });

    //Event to trigger unlock warning
    $rootScope.$on('unlock', function (event) {
        $scope.unlockOn = true;
        $scope.unlockMsg = "Select a Property";
        $timeout(function () {
            $scope.unlockOn = false;
        }, 2500);
    });

    //Event to trigger unlock warning
    $rootScope.$on('devmessage', function (event) {
        $scope.devResults = true;
        $scope.devMsg = "No Development Applications Found";
        $timeout(function () {
            $scope.devResults = false;
        }, 1000);
    });

    //Event to toggle all location information on Google Maps
    $rootScope.$on('locationToggle', function (event) {
        if ($rootScope.isDev) {
            var styleArray = [
                {
                    featureType: "all",
                    stylers: [
                        { visibility: "off" }
                    ]
                },
                {
                    featureType: "road",
                    stylers: [
                        { visibility: "on" }
                    ]
                },
                {
                    featureType: "water",
                    stylers: [
                        { visibility: "on" }
                    ]
                }
            ];

            $scope.map.setOptions({ styles: styleArray });
        } else if (!$rootScope.isDev) {
            var styleArray = [
                {
                    featureType: "all",
                    stylers: [
                        { visibility: "on" }
                    ]
                },
                {
                    featureType: "road",
                    stylers: [
                        { visibility: "on" }
                    ]
                }
            ];

            $scope.map.setOptions({ styles: styleArray });
        }
    });

    //Event triggered when a route begins to change
    $rootScope.$on('$routeChangeStart', function () {
        //Show the user the first tutorial
        if ($location.search().address && $location.path() == '/') {
            $scope.tutorialCount(1);
        }

        if (!$scope.startSearch)//Obtain search value from coordinatesUtils and set it in mapping page
        {
            if ($rootScope.userAgent.indexOf('Mobile') != -1) {
                ngDialog.open({
                    template: '/templates/mobile-warning.tpl.html',
                    controller: 'Tut1Ctrl',
                    className: 'tutorial-theme',
                    closeByEscape: false,
                    closeByDocument: false,
                    showClose: false
                });
            }
            if ($rootScope.userAgent.indexOf('MSIE 9.0') != -1)
                ngDialog.open({
                    template: '/templates/ie9-warning.tpl.html',
                    controller: 'Tut1Ctrl',
                    className: 'tutorial-theme',
                    closeByEscape: false,
                    closeByDocument: false,
                    showClose: false
                });

            if ($rootScope.userAgent.indexOf('MSIE 10.0') != -1)
                $scope.IEactive = true;

            if ($location.search().address && !$location.search().lat && !$location.search().lng) {
                $scope.startSearch = true;
                $scope.model.address = $location.search().address;
                if (!$scope.isZoom) {
                    $scope.findLocationWithGeoCoder();
                }
            } else if ($location.search().address && $location.search().lat && $location.search().lng) {
                if (!$scope.initSearch) {
                    $scope.initSearch = true;
                    $scope.setLocationwithURL();// This will load the information from the URL
                }
            }
        }
        if ($route.current && $route.current.params !== undefined)
            $scope.lastParam = $route.current.params;
    });

    /******* Google Map Events *******/
    //Extended Polygon class to get the center of the polygon
    google.maps.Polygon.prototype.my_getBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        this.getPath().forEach(function (element, index) { bounds.extend(element) });
        return bounds;
    };

    //Drag event for the marker
    google.maps.event.addListener($scope.marker, 'drag', function () {
        $scope.geocoder.geocode({ 'latLng': $scope.marker.getPosition() }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                $scope.setInfoContent(results[0].formatted_address);
            }
        });
    });

    //Dragstart event for the marker
    google.maps.event.addListener($scope.marker, 'dragstart', function () {
        if ($scope.isInfoWindowOpen($scope.initialWindow))
            $scope.initialWindow.close();
        if ($scope.isInfoWindowOpen($scope.addressWindow))
            $scope.addressWindow.close();
        //$scope.addressBox.close();
    });

    //Dragend event for the marker
    google.maps.event.addListener($scope.marker, 'dragend', function () {
        //$scope.addressBox.open($scope.map,$scope.marker);
        $scope.initialWindow.open($scope.map, $scope.marker);
    });

    //Click event for the map
    google.maps.event.addListener($scope.map, 'click', function (event) {
        const { latLng: { lat, lng } } = event;
        console.log(event);

        $rootScope.$broadcast('sidebar/devapp/updatecoordinates', [lat(), lng()]);

        if (!$scope.isHover) {
            if (!$scope.clickPolyOn)
                $scope.clickPolyOn = true;
            $scope.watchPolygon('mapClick', event);
        }
    });
    //Mousemove event for the map
    google.maps.event.addListener($scope.map, 'mousemove', function (event) {
        $timeout.cancel($scope.geoInterval);

        $scope.gLat = event.latLng.lat();
        $scope.gLng = event.latLng.lng();

        if ($scope.mouseMoveOn) {
            //If mouse has not moved and geometry hasn't been called then call geometry after 200ms interval
            //Else if mouse has been called cancel interval or geometry has been called cancel interval
            //Get mouse coordinates
            $scope.watchPolygon('mapMouseover', event);
        }
    });

    google.maps.event.addListener($scope.bermudaTriangle, 'mousemove', function (event) {
        $timeout.cancel($scope.geoInterval);
    });

    google.maps.event.addListener($scope.bermudaTriangle, 'mouseout', function (event) {
        $timeout.cancel($scope.geoInterval);
    });

    //Click event for bermudaTriangle
    google.maps.event.addListener($scope.bermudaTriangle, 'click', function (event) {
        if ($scope.mouseMoveOn) {
            if ($scope.clickPolyOn)
                $scope.clickPolyOn = false;
        }
        if ($scope.clickPolyOn) {
            this.setMap(null);
            $scope.mouseMoveOn = true;
        }
        else {
            //turn on polygon
            $scope.watchPolygon('polygonClick', event);
        }
    });

    //Click event for polygon
    google.maps.event.addListener($scope.polyTriangle, 'click', function (event) {
        if ($rootScope.isDev) {
            const { latLng } = event;
            $rootScope.$broadcast('sidebar/devapp/update', [latLng.lat(), latLng.lng()]);
        }
    });

    //Zoom event for when it changes
    google.maps.event.addListener($scope.map, 'zoom_changed', function () {
        $rootScope.report.zoom = $scope.map.getZoom();
        $rootScope.$broadcast('sidebar/report/zoom', $scope.map.getZoom());
        if ($rootScope.previousZoom == 15 && $scope.map.getZoom() == 14) {
            $scope.parcelOn = true;
            $scope.zoomMsg = "Parcel & Contour layers are turned off at this zoom level, zoom in to turn them back on";
            $scope.$apply();
            $timeout(function () {
                $scope.parcelOn = false;
            }, 6000);
        }
        if ($scope.map.getZoom() < 14) {
            $scope.isZoom = true;
            if (!$scope.canToggle)
                $scope.canToggle = true;
            $scope.wakeParcel();
        }
        $rootScope.previousZoom = $scope.map.getZoom();
    });

    //Event for seeing when the mouse leaves the map
    google.maps.event.addListener($scope.bermudaTriangle, 'mouseout', function () {

    });

    //Monitor when map is idle
    google.maps.event.addListener($scope.map, 'idle', function (event) {
        $rootScope.layerLoaded = true;
    });

    /*** Controller broadcast events ***/

    //Control when the parcel is locked/unlocked
    $rootScope.$on('parcelAccess', function (event, data) {
        $rootScope.isDev = data;
    });

    //When the users access to the sidebar needs to be set, this is called
    $rootScope.$on('sidebarAccess', function (event) {
        authenticationService.accessCheck($rootScope.user_access).success(function (data) {
            for (var i = 0; i < data.length; i++) {
                $rootScope.user_access.push(data[i]);
            }
        });

        for (var i = 0; i < $scope.categories.length; i++) {
            $scope.categories[i].access = $scope.user_access[i];
        }
        console.log($scope.categories);
    });

    //When the user successfully logs in, make sure the top bar switches to show the user info
    $rootScope.$on(AUTH_EVENTS.loginSuccess, function (event, data) {
        $scope.isLog = false;
        $scope.isUser = true;

        $rootScope.currentUser = data;
        $rootScope.currentUser.name = capitalizeUserName($rootScope.currentUser.name);

        var res = $rootScope.currentUser.name.split(' ');
        $rootScope.username = res[0];
        $scope.isLog = false;
        $scope.isUser = true;

        if ($rootScope.userPath != "") {
            if ($rootScope.userPath == '/official-plan' || $rootScope.userPath == '/by-law') {
                var layer = $rootScope.userPath.replace('/', '');
                $scope.categoryLayer(layer);
                $rootScope.userPath = "";
            }
        } else {

        }

    });

    //Check the users account type and determine which features to enable for them. All features are turned off by default.
    $rootScope.$on(AUTH_EVENTS.platformAuthentication, function (event, data) {
        //Enable or disable report function for user.
        authenticationService.isReportAuthenticated().success(function (data) {
            $rootScope.reportFeature = data;
        });
    });

    $scope.$on('callSubmit', function (event, place) {
        $scope.googlePlace = place;// Store passed in place obj into scoped variable
        $scope.checkAddress();// Call checkAddress to perfrom validation of google place results
    });

    //When called this will perform the cut off check on the user that is already signed in.
    $scope.$on('cutoffCheck', function (event, data) {
        authenticationService.cutoffcheck($rootScope.currentUser).success(function (data) {
            if (data.cut_off == 'expire') {
                $scope.logout();
                ngDialog.closeAll();
                ngDialog.open({
                    templateUrl: 'templates/trial-ended.tpl.html',
                    className: 'ngdialog-theme-plain'
                });
                $location.path('/prime');
            }
        }).error(function (data) {

        });
    });

    //When called this will check if the user has a redirect cookie, if they don't, it will check for eligibility
    $scope.$on('redirectCookie', function (event, data) {
        authenticationService.getRedirectCookie().success(function (data) {
            if (data.redirect == "not set") {
                authenticationService.setRedirectCookie().success(function (data) {
                    if (data.redirect == "redirect")
                        authenticationService.redirectUser();//Redirect User
                });//Set the user up with a cookie
            }
            else if (data.redirect == "is set")
                authenticationService.redirectUser();//Send the user on their way
        });
    });

    //When the user successfully logs out make sure the top bar switches to default
    $scope.$on(AUTH_EVENTS.logoutSuccess, function (event, data) {
        $scope.isLog = true;
        $scope.isUser = false;

        /* Turn off all prime features */
        $rootScope.reportFeature = false;
        $scope.layersOff();
        $location.path('/prime');

        $rootScope.currentUser = { "acc_type": USER_ROLES.GUEST };

        authenticationService.accessCheck($rootScope.user_access).success(function (data) {
            for (var i = 0; i < data.length; i++) {
                $rootScope.user_access.push(data[i]);
            }
        });
        console.log($rootScope.user_access);
        //Update the users access to the sidebar buttons
        for (var i = 0; i < $scope.categories.length; i++) {
            $scope.categories[i].access = $scope.user_access[i];
        }

        $scope.showLogin();
    });

    //Used to call register form
    $scope.$on('callSignup', function (event, data) {

    });

    /******* Controller Functions *******/

    //Check if infoWindow passed in is open or not
    $scope.isInfoWindowOpen = function (infoWindow) {
        var map = infoWindow.getMap();
        return (map !== null && typeof map !== "undefined");
    };

    /* create n-dimenstional array */
    $scope.createArray = function (length) {
        var arr = new Array(length || 0),
            i = length;

        if (arguments.length > 1) {
            var args = Array.prototype.slice.call(arguments, 1);
            while (i--) arr[length - 1 - i] = $scope.createArray.apply(this, args);
        }
        return arr;
    };

    /* Show more functionality */


    //Create WMS layer call
    $scope.makeWMSLayer = function (layer, type) {
        if (type == 'wms') {

            return new google.maps.ImageMapType({

                getTileUrl: function (coord, zoom) {
                    var proj = $scope.map.getProjection();
                    var zfactor = Math.pow(2, zoom);
                    // get Long Lat coordinates
                    var top = proj.fromPointToLatLng(new google.maps.Point(coord.x * 256 / zfactor, coord.y * 256 / zfactor));
                    var bot = proj.fromPointToLatLng(new google.maps.Point((coord.x + 1) * 256 / zfactor, (coord.y + 1) * 256 / zfactor));

                    var deltaX = 0; // Any corrections in X,Y needed (none at this point)
                    var deltaY = 0;

                    //create the Bounding box string
                    var bbox = (top.lng() + deltaX) + "," +
                        (bot.lat() + deltaY) + "," +
                        (bot.lng() + deltaX) + "," +
                        (top.lat() + deltaY);

                    return $window.url_gs_dev_app + "service=WMS" + "&version=1.1.0" + "&request=GetMap" + "&layers=" + layer.link + "&zoom=" + zoom + "&styles=" + "&BBOX=" + bbox + "&WIDTH=256" + "&HEIGHT=256" + "&srs=EPSG:4326" + "&format=" + layer.format + "&bgcolor=0xFFFFFF" + "&transparent=TRUE" + "&tiled=true";
                },
                tileSize: new google.maps.Size(layer.size, layer.size),
                isPng: layer.isPng,
                opacity: layer.opacity,
                name: layer.name,
                alt: layer.type

            });
        }
    };

    // Set locaiton based on URL paramters
    $scope.setLocationwithURL = function () {
        $scope.model.address = $location.search().address; // Set input on map page with URL value

        $scope.coverage = { lat: 0, lng: 0 };// Reset the coverage obj
        $scope.coverage.lng = $location.search().lng;// Set the coverage lng
        $scope.coverage.lat = $location.search().lat;// Set the coverage lat

        $scope.wakeParcel();//Turn on parcel layer
        $scope.setInfoContent($scope.model.address, "initial");
        $scope.isSearchBar = true;
        $rootScope.isPropertySelected = false;

        if ($scope.bermudaTriangle.getMap())
            $scope.bermudaTriangle.setMap(null);
        if ($scope.polyTriangle.getMap())
            $scope.polyTriangle.setMap(null);

        //Hide report button
        $rootScope.hasProperty = false;

        sidebarService.coverageInfo($scope.coverage).success(() => { });

        $scope.marker.setIcon("https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|7d8284");
        var location = new google.maps.LatLng($scope.coverage.lat, $scope.coverage.lng);
        $scope.marker.setPosition(location);
        if ($scope.isInfoWindowOpen($scope.addressWindow))
            $scope.addressWindow.close();
        $scope.initialWindow.open($scope.map, $scope.marker);
        $scope.map.setCenter($scope.marker.getPosition());
        $scope.map.setZoom(18);
        $scope.map.panBy(-250, 0);
        if ($scope.canToggle == false)
            $scope.canToggle = true;

        if ($rootScope.isDev == true) {
            $rootScope.$broadcast('unlock');
            $rootScope.parcelLock = false;
        }

    };

    // Set location with address passed in from dialog input
    $scope.findLocationWithGeoCoder = function () {
        var geocoder = new google.maps.Geocoder(); // Create new Geocoder instance

        // Perform geocoding operation
        geocoder.geocode({ 'address': $scope.model.address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                $scope.map.setCenter(results[0].geometry.location);// Set the center of the map
                $scope.coverage = { lat: 0, lng: 0 };// Reset the coverage obj

                $scope.coverage.lng = results[0].geometry.location.lng();// Set the coverage lng
                $scope.coverage.lat = results[0].geometry.location.lat();// Set the coverage lat

                $location.search('lat', results[0].geometry.location.lat());// Set lat information
                $location.search('lng', results[0].geometry.location.lng());// Set lng information

                $scope.wakeParcel();//Turn on parcel layer
                $scope.setInfoContent($scope.model.address, "initial");
                $scope.isSearchBar = true;
                $rootScope.isPropertySelected = false;
                $scope.clearSidebar();

                if ($scope.bermudaTriangle.getMap())
                    $scope.bermudaTriangle.setMap(null);
                if ($scope.polyTriangle.getMap())
                    $scope.polyTriangle.setMap(null);

                //Hide report button
                $rootScope.hasProperty = false;

                sidebarService.coverageInfo($scope.coverage).success(() => { });

                $scope.marker.setIcon("https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|7d8284");
                $scope.marker.setPosition(results[0].geometry.location);
                if ($scope.isInfoWindowOpen($scope.addressWindow))
                    $scope.addressWindow.close();
                $scope.initialWindow.open($scope.map, $scope.marker);
                $scope.map.setCenter($scope.marker.getPosition());
                $scope.map.setZoom(18);
                $scope.map.panBy(-250, 0);
                if ($scope.canToggle == false)
                    $scope.canToggle = true;

                if ($rootScope.isDev == true) {
                    $rootScope.$broadcast('unlock');
                    $rootScope.parcelLock = false;
                }

            } else {
                $scope.canToggle = false;
                alert('The address you entered was not valid please try again');
            }


        });
    };

    $scope.findLocationWithPlaces = function (googlePlaceObj) {
        if (!googlePlaceObj) {
            alert('An issue occured with your search, please reload and try again');
            console.log('log error');
        } else {
            var place = googlePlaceObj.getPlace();
            var recenteredGeometry = jQuery.Deferred();

            // Check if place information was returned
            if (!place.geometry) {
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({
                    address: place.name
                }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        place.geometry = results[0].geometry;
                        recenteredGeometry.resolve();
                    } else {
                        alert('The address you entered was not valid please try again');
                    }
                });
            } else {
                recenteredGeometry.resolve();
            }

            var recenterOnGeometry = function () {
                $scope.wakeParcel();//Turn on parcel layer

                $scope.setInfoContent(place.name, "initial");

                $scope.isSearchBar = true;
                $rootScope.isPropertySelected = false;
                $scope.clearSidebar();

                if ($scope.bermudaTriangle.getMap())
                    $scope.bermudaTriangle.setMap(null);
                if ($scope.polyTriangle.getMap())
                    $scope.polyTriangle.setMap(null);

                //Hide report button
                $rootScope.hasProperty = false;

                // Set the map
                $scope.map.setCenter(place.geometry.location);// Set map to the location
                $scope.map.setZoom(18);// Set the default zoom level
                $scope.map.panBy(-250, 0);// Pan the map to take in account the sidebar
                $scope.coverage = { lat: 0, lng: 0 };

                if (place.geometry.viewport !== undefined) {
                    if (place.geometry.viewport.O != undefined) {
                        $scope.coverage.lng = place.geometry.viewport.O.j;
                        $scope.coverage.lat = place.geometry.viewport.j.j;
                    } else if (place.geometry.viewport.R != undefined) {
                        $scope.coverage.lng = place.geometry.viewport.R.j;
                        $scope.coverage.lat = place.geometry.viewport.j.j;
                    }
                } else if (place.geometry.viewport === undefined) {
                    console.log('log error');
                }

                sidebarService.coverageInfo($scope.coverage).success(() => { });

                $scope.marker.setIcon("https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|7d8284");
                $scope.marker.setPosition(place.geometry.location);
                if ($scope.isInfoWindowOpen($scope.addressWindow))
                    $scope.addressWindow.close();
                $scope.initialWindow.open($scope.map, $scope.marker);

                if ($scope.canToggle == false)
                    $scope.canToggle = true;

                if ($rootScope.isDev == true) {
                    $rootScope.$broadcast('unlock');
                    $rootScope.parcelLock = false;
                }
            };

            recenteredGeometry.then(recenterOnGeometry.bind(this));
        }
    };

    //Monitor model.address on all submits
    $scope.checkAddress = function () {
        if (!$location.search().address) {
            $location.search('address', $scope.model.address);// Add address to url
        }
        if ($scope.googlePlace === null) {
            console.log('Address is coming from the URL');
            var gPlace = new google.maps.places.PlacesService($scope.map);
        } else if ($scope.googlePlace !== null) {
            console.log('Address is coming from the user');
            var place = $scope.googlePlace.getPlace();// seperate the place information

            // check if the search result returned any information
            if (!place.geometry) {
                alert('No details available for input: ' + place.name);
                return;
            }

            $scope.wakeParcel();//Turn on parcel layer
        }
        $scope.geocoder.geocode({ 'address': $scope.model.address }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                $scope.wakeParcel();//Turn on parcel layer
                $scope.setInfoContent($scope.model.address, "initial");
                $scope.isSearchBar = true;
                $rootScope.isPropertySelected = false;
                $scope.clearSidebar();

                if ($scope.bermudaTriangle.getMap())
                    $scope.bermudaTriangle.setMap(null);
                if ($scope.polyTriangle.getMap())
                    $scope.polyTriangle.setMap(null);

                //Hide report button
                $rootScope.hasProperty = false;

                console.log(results[0].geometry.viewport);

                $scope.map.setCenter(results[0].geometry.location);
                $scope.coverage = { lat: 0, lng: 0 };

                console.log(results[0].geometry.location);

                if (results[0].geometry.viewport != undefined) {
                    if (results[0].geometry.viewport.O != undefined) {
                        $scope.coverage.lng = results[0].geometry.viewport.O.j;
                        $scope.coverage.lat = results[0].geometry.viewport.j.j;
                    } else if (results[0].geometry.viewport.R != undefined) {
                        $scope.coverage.lng = results[0].geometry.viewport.R.j;
                        $scope.coverage.lat = results[0].geometry.viewport.j.j;
                    }
                }

                sidebarService.coverageInfo($scope.coverage).success(() => { });

                $scope.marker.setIcon("https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|7d8284");
                $scope.marker.setPosition(results[0].geometry.location);
                if ($scope.isInfoWindowOpen($scope.addressWindow))
                    $scope.addressWindow.close();
                $scope.initialWindow.open($scope.map, $scope.marker);
                $scope.map.setCenter($scope.marker.getPosition());
                $scope.map.setZoom(18);
                $scope.map.panBy(-250, 0);
                if ($scope.canToggle == false)
                    $scope.canToggle = true;

                if ($rootScope.isDev == true) {
                    $rootScope.$broadcast('unlock');
                    $rootScope.parcelLock = false;
                }
            }
            else {
                $scope.canToggle = false;
                alert('The address you entered was not valid please try again');
            }
        });
    };

    $scope.setInfoContent = function (content, type) {
        if (content != 'test')
            $location.search('address', content);
        if (type == "dev-address" || type == "address") {
            const addressWindowTemplate = template(addressWindow);
            const renderedTemplate = addressWindowTemplate({ content, type });

            $scope.addressWindow.setContent(renderedTemplate);
        } else if (type == "initial") {
            const initialWindowTemplate = template(initialWindowDev);
            const renderedTemplate = initialWindowTemplate({ content });

            $scope.initialWindow.setContent(renderedTemplate);
        }
    };

    //Toggle multi layers
    $scope.multiToggle = function (layers) {
        if ($scope.canToggle && $rootScope.mapLayers) {
            for (var i = 0; i < layers.length; i++) {
                $scope.toggleLayer(layers[i]);
            }
        }
    };

    //Monitor layer toggling for categories
    $scope.toggleLayer = function (name) {
        if ($scope.canToggle && $scope.propClick) {
            for (var index in $rootScope.mapLayers) {
                if ($rootScope.mapLayers[index].name == name.toLowerCase()) {
                    if ($scope.map.overlayMapTypes.getAt(index) == null) {
                        $scope.map.overlayMapTypes.setAt(index, $rootScope.mapLayers[index]);
                    }
                    else {
                        $scope.map.overlayMapTypes.setAt(index, null);
                    }
                }
            }
        }
    };

    //Turn off all active layers
    $scope.layersOff = function () {
        for (var index in $rootScope.mapLayers) {
            if ($scope.map.overlayMapTypes.getAt(index) != null) {
                $scope.map.overlayMapTypes.setAt(index, null);
            }
        }
    };

    //Monitor layer toggling for categories
    $scope.checkLayer = function (name) {
        if ($scope.canToggle && $scope.propClick) {
            for (var index in $rootScope.mapLayers) {
                if ($rootScope.mapLayers[index].name == name.toLowerCase()) {
                    if ($scope.map.overlayMapTypes.getAt(index) == null)
                        return true;
                    else
                        return false;
                }
            }
        }
    };

    //Turn off all layers that are on, except parcel. Called when URL is /summary?address
    $scope.layersOff = function () {
        if ($scope.canToggle && $scope.propClick) {
            for (var index in $rootScope.mapLayers) {
                if ($rootScope.mapLayers[index].name != "parcel") {
                    if ($scope.map.overlayMapTypes.getAt(index) != null && $scope.map.overlayMapTypes.getAt(index) != undefined)
                        $scope.map.overlayMapTypes.setAt(index, null);
                }
            }
        }
    };

    $scope.reactivateLayers = function () {
        $rootScope.$broadcast('sidebar/devapp/toggle', false);
        $rootScope.$broadcast('sidebar/official/toggle', false);
        $rootScope.$broadcast('sidebar/citywide/toggle', false);
        $rootScope.$broadcast('sidebar/bylaw/toggle', false);
        $rootScope.$broadcast('sidebar/water/toggle', false);
        $rootScope.$broadcast('sidebar/environ/toggle', false);
        $rootScope.$broadcast('sidebar/provincial/toggle', false);
    };

    //Turn on category layers if they're not already on & turn off all other layers but parcel
    $scope.categoryLayer = function (name) {
        if (name != 'dev-app-toronto') {
            $scope.map.overlayMapTypes.setAt(45, null);
            $scope.map.overlayMapTypes.setAt(47, null);
        }

        $scope.reactivateLayers(); //ReToggle all layers to get rid of togle on/off bug

        if ($scope.onSidebar)
            $scope.onSidebar = false;
        if ($scope.isSearchBar)
            $scope.isSearchBar = false;
        $scope.checkSearch();
        if ($scope.canToggle && $scope.propClick) {
            $scope.changePath(name);
            for (var index in $rootScope.mapLayers) {
                if ($rootScope.mapLayers[index].alt == name.toLowerCase()) {
                    if (name == 'by-law' || name == 'official-plan' || name == 'water' || name == 'environment' || name == 'provincial-plan' || name == 'dev-app-toronto' || name == "op-citywide-toronto") {
                        if ($scope.isUser) {
                            if ($scope.map.overlayMapTypes.getAt(index) == null && layers[index].isDefault) {
                                $scope.map.overlayMapTypes.setAt(index, $rootScope.mapLayers[index]);
                            }
                        }
                    } else {
                        if ($scope.map.overlayMapTypes.getAt(index) == null && layers[index].isDefault) {
                            var test = $scope.map.overlayMapTypes.setAt(index, $rootScope.mapLayers[index]);
                        }
                    }
                }
                else if ($rootScope.mapLayers[index].name != "parcel") {
                    if ($scope.map.overlayMapTypes.getAt(index) != null && $scope.map.overlayMapTypes.getAt(index) != undefined)
                        $scope.map.overlayMapTypes.setAt(index, null);
                }
            }
        }
        if (!$rootScope.isPropertySelected) {
            //Clear the sidebar since a new category is about to be shown
            $scope.clearSidebar();
        }

    };

    //Turn parcel layer on
    $scope.wakeParcel = function () {
        for (var index in $rootScope.mapLayers) {
            if ($rootScope.mapLayers[index].name == "parcel") {
                if ($scope.map.overlayMapTypes.getAt(index) == null) {
                    $scope.map.overlayMapTypes.setAt(index, $rootScope.mapLayers[index]);
                    layers[index].isOn = !layers[index].isOn;
                }
                else
                    return index;
            }
        }
    };

    //Get the property information from the property that the user is hovering over
    $scope.getPropertyInfo = function () {
        var index = $scope.wakeParcel();
        $scope.geo = { lng: 0, lat: 0 };
        if (layers[index].isOn || $rootScope.isDev == true) {
            $scope.geoInterval = $timeout(function () {
                $scope.geo.lng = $scope.gLng;
                $scope.geo.lat = $scope.gLat;
                //Put a service here that will call to the geo, turn into POST call
                sidebarService.geoInfo($scope.geo).success(function (data) {
                    var features = data.features;

                    // get coordinates when mouse hovering
                    if (typeof features !== "undefined" && features[0] && features[0].geometry && features[0].geometry.coordinates) {
                        $scope.propertyInfo.coords = features[0].geometry.coordinates;

                        $scope.propertyInfo.gid = features[0].properties.gid;
                        $scope.propertyInfo.myp_municipality = nullornot(features[0].properties.myp_municipality);
                        $scope.propertyInfo.location = features[0].properties.myp_address;
                        $scope.propertyInfo.myp_area_ha = features[0].properties.myp_area_ha;
                        $scope.propertyInfo.geomextent = features[0].properties.geomextent;
                        $scope.propertyInfo.geomextent_width_m = features[0].properties.geomextent_width_m;
                        $scope.propertyInfo.geomextent_height_m = features[0].properties.geomextent_height_m;

                        if ($scope.propertyInfo.coords !== null) {
                            $scope.setPolyHover();
                        }

                        $scope.bermudaTriangle.setOptions($scope.polygonOptions);
                        $scope.bermudaTriangle.setMap($scope.map);

                    } else {
                        console.log('Not hovering on parcel...');
                        $scope.propertyInfo.coords = null; // or any other appropriate value or error handling
                    }

                }).error(function (data) {

                })

            }, 75);
            return 0;
        }
        else
            $scope.wakeParcel();
    };

    //Set the property information into the system so that the report & sidebar can be populated
    $scope.setPropertyInfo = function () {
        if ($rootScope.isDev == true) {
            $rootScope.propNumber = nullornot($scope.propertyInfo.gid);

            $scope.sidebar.gid = $rootScope.propNumber;
            $scope.sidebar.myp_municipality = nullornot($scope.propertyInfo.myp_municipality);

            $rootScope.myp_municipality = nullornot($scope.propertyInfo.myp_municipality);
            $scope.myp_municipality = $rootScope.myp_municipality;

            $rootScope.myp_area_ha = $scope.propertyInfo.myp_area_ha;
            $scope.myp_area_ha = $rootScope.myp_area_ha;

            $rootScope.geomextent = $scope.propertyInfo.geomextent;
            $scope.geomextent = $rootScope.geomextent;

            $rootScope.geomextent_width_m = $scope.propertyInfo.geomextent_width_m;
            $scope.geomextent_width_m = $rootScope.geomextent_width_m;

            $rootScope.geomextent_height_m = $scope.propertyInfo.geomextent_height_m;
            $scope.geomextent_height_m = $rootScope.geomextent_height_m;

            $rootScope.$broadcast('sidebar/devapp/updatedevaddress', $scope.propertyInfo);
            $rootScope.$broadcast('sidebar/report/updatereportgidandaddress', $scope.propertyInfo);

            $rootScope.address = nullornot($scope.propertyInfo.location) + ', ' + $scope.propertyInfo.myp_municipality;
            $scope.setInfoContent($rootScope.address, "dev-address");

        } else {
            $rootScope.isPropertySelected = true;
            console.log('clicked gid: ' + $scope.propertyInfo.gid);

            $rootScope.propNumber = nullornot($scope.propertyInfo.gid);

            $scope.sidebar.gid = nullornot($scope.propertyInfo.gid);
            $scope.sidebar.myp_municipality = nullornot($scope.propertyInfo.myp_municipality);

            $rootScope.myp_municipality = nullornot($scope.propertyInfo.myp_municipality);
            $scope.myp_municipality = $rootScope.myp_municipality;

            $rootScope.myp_area_ha = $scope.propertyInfo.myp_area_ha;
            $scope.myp_area_ha = $rootScope.myp_area_ha;

            $rootScope.geomextent = $scope.propertyInfo.geomextent;
            $scope.geomextent = $rootScope.geomextent;

            $rootScope.geomextent_width_m = $scope.propertyInfo.geomextent_width_m;
            $scope.geomextent_width_m = $rootScope.geomextent_width_m;

            $rootScope.geomextent_height_m = $scope.propertyInfo.geomextent_height_m;
            $scope.geomextent_height_m = $rootScope.geomextent_height_m;

            $rootScope.$on('sidebar/devapp/updatedevaddress', $scope.propertyInfo);
            $rootScope.$broadcast('sidebar/report/updatereportgidandaddress', $scope.propertyInfo);

            $rootScope.address = nullornot($scope.propertyInfo.location) + ', ' + $scope.propertyInfo.myp_municipality;

            $scope.setInfoContent($rootScope.address, "address");

        }
    };

    //GET request on passed in URL
    $scope.httpGet = function (URL) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("GET", URL, false);
        xmlHttp.send(null);
        return xmlHttp.responseText;
    };

    $scope.msieversion = function () {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE");

        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            return true;//is IE
        }
        else {
            return false;
        }
    };

    //Set polygon coordinates & options
    $scope.setPoly = function () {
        $scope.triangleCoords = new google.maps.MVCArray();
        for (var i = 0; i < $scope.propertyInfo.coords[0][0].length; i++)
            // Latitude and Longitude are swapped apparently in new version of WMS for Geoserver 2.6; use this:
            $scope.triangleCoords.push(new google.maps.LatLng($scope.propertyInfo.coords[0][0][i][1], $scope.propertyInfo.coords[0][0][i][0]));
        //$scope.triangleCoords.push(new google.maps.LatLng($scope.coords[0][0][i][0], $scope.coords[0][0][i][1]));

        $scope.polygonOptions = {
            paths: $scope.triangleCoords,
            strokeColor: "#FF0000",
            strokeOpacity: 0.7,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.2
        };

        $rootScope.isPropertySelected = true;
    };

    //Set polygon coordinates & options
    $scope.setPolyHover = function () {
        $scope.triangleCoords = new google.maps.MVCArray();
        for (var i = 0; i < $scope.propertyInfo.coords[0][0].length; i++)
            // Latitude and Longitude are swapped apparently in new version of WMS for Geoserver 2.6; use this:
            $scope.triangleCoords.push(new google.maps.LatLng($scope.propertyInfo.coords[0][0][i][1], $scope.propertyInfo.coords[0][0][i][0]));
        //$scope.triangleCoords.push(new google.maps.LatLng($scope.coords[0][0][i][0], $scope.coords[0][0][i][1]));

        $scope.polygonOptions = {
            paths: $scope.triangleCoords,
            strokeColor: "#414141",
            strokeOpacity: 0.7,
            strokeWeight: 2,
            fillColor: "#414141",
            fillOpacity: 0.2
        };
    };

    //Change path and retain the address in the URL
    $scope.changePath = function (pathUrl) {
        $location.path(pathUrl);

        // // MYPC-119 2024-01-30 As per Devin, do NOT track/log history when user switches sidebar, only track parcel clicks
        if ($scope.history.address != $rootScope.address || ($scope.history.lat != $scope.geo.lat && $scope.history.lng != $scope.geo.lng)) {
            //Store searches of clicked property into history array.
            $scope.history.address = $rootScope.address;
            $scope.history.lat = $scope.geo.lat;
            $scope.history.lng = $scope.geo.lng;
            $scope.history.url = $location.url();

            $scope.savehistory();
        }
    };

    //Function for click and hover on polygon
    $scope.watchPolygon = function (type, event) {
        var pixel = 0;
        var bounds = 0;
        if ($scope.canToggle && $scope.map.getZoom() >= 15) {
            switch (type) {
                case 'mapClick':
                    //Perform cut off check
                    $rootScope.$broadcast('cutoffCheck');
                    if ($scope.isInfoWindowOpen($scope.initialWindow))
                        $scope.initialWindow.close();
                    if ($scope.isInfoWindowOpen($scope.addressWindow))
                        $scope.addressWindow.close();
                    //$scope.addressBox.close();
                    pixel = $scope.overlay.getProjection().fromLatLngToContainerPixel(event.latLng);
                    bounds = $scope.map.getBounds();
                    //Determine if the user is in dev app mode or not
                    if ($rootScope.isDev == true) {
                        const { latLng } = event;
                        $rootScope.$broadcast('sidebar/devapp/updatedevcoords', [latLng.lat(), latLng.lng()]);
                        //Call service to get the dev app information
                        $rootScope.$broadcast('sidebar/devapp/updateddevappinfo');
                        if ($rootScope.parcelLock) {//Parcel can't be clicked in dev app mode

                        } else {//Parcel can be clicked in dev app mode
                            $scope.setPropertyInfo();
                        }
                    } else {
                        $scope.setPropertyInfo();

                        if ($scope.propertyInfo.coords !== null) {
                            $scope.setPoly();
                        }

                        $scope.bermudaTriangle.setOptions($scope.polygonOptions);

                        $scope.bermudaTriangle.setMap($scope.map);

                    }
                    break;
                case 'mapMouseover':
                    pixel = $scope.overlay.getProjection().fromLatLngToContainerPixel(event.latLng);
                    bounds = $scope.map.getBounds();

                    //Determine if the user is in dev app mode or not
                    if ($rootScope.isDev == true) {
                        if ($rootScope.parcelLock) {//Parcel can't be clicked in dev app mode
                            $scope.bermudaTriangle.setMap(null);//Turn off any hover polygons
                        } else
                            $scope.getPropertyInfo();//Parcel can be clicked in dev app mode
                    } else
                        $scope.getPropertyInfo();
                    break;
                case 'polygonClick':
                    //Perform cut off check
                    $rootScope.$broadcast('cutoffCheck');
                    $rootScope.hasProperty = true;
                    if ($scope.isInfoWindowOpen($scope.initialWindow))
                        $scope.initialWindow.close();
                    if ($scope.isInfoWindowOpen($scope.addressWindow))
                        $scope.addressWindow.close();
                    //$scope.addressBox.close();
                    pixel = $scope.overlay.getProjection().fromLatLngToContainerPixel(event.latLng);
                    bounds = $scope.map.getBounds();

                    // Set the lat and lng of the url
                    $location.search('lat', event.latLng.lat());// Set lat information
                    $location.search('lng', event.latLng.lng());// Set lng information

                    //Determine if the user is in dev app mode or not
                    if ($rootScope.isDev == true) {
                        if (!$rootScope.parcelLock) {
                            //$scope.coords = $scope.getPropertyInfo(bounds, document.getElementById('map-canvas').offsetWidth, document.getElementById('map-canvas').offsetHeight, pixel, 'click');
                            $scope.setPropertyInfo();
                            $scope.setPoly();

                            $scope.marker.setIcon($scope.prop_icon);
                            $scope.marker.setPosition(event.latLng);

                            if ($rootScope.currentUser.acc_type != $scope.userRoles.GUEST) {
                                //Save clicked property into database
                                $scope.changePath($location.path());
                            }

                            $scope.polyTriangle.setOptions($scope.polygonOptions);

                            $scope.marker.setPosition(event.latLng);

                            $scope.addressWindow.open($scope.map, $scope.marker);
                            //$scope.addressBox.open($scope.map,$scope.marker);
                            $scope.polyTriangle.setMap($scope.map);
                            $scope.map.setCenter($scope.marker.getPosition());
                            $scope.map.panBy(-250, 0);

                            $rootScope.lng4326 = $scope.polyTriangle.my_getBounds().getCenter().lng();
                            $rootScope.lat4326 = $scope.polyTriangle.my_getBounds().getCenter().lat();

                            // EPSG:900913 (OpenStreetMap conversion)
                            var coord = proj4('EPSG:4326', 'EPSG:900913', [$rootScope.lng4326, $rootScope.lat4326]);
                            $rootScope.lng = coord[0];
                            $rootScope.lat = coord[1];
                            $rootScope.$broadcast('sidebar/report/updatereportcoordinates', [$rootScope.lat, $rootScope.lng]);

                            // EPSG:2952 (Ontario conversion)
                            var coord_ontario = proj4('EPSG:4326', '+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs', [$rootScope.lng4326, $rootScope.lat4326]);
                            $rootScope.lng2019 = coord_ontario[0];
                            $rootScope.lat2019 = coord_ontario[1];

                            $rootScope.parcelLock = true;//Lock Parcel click because we're still in dev app mode
                        }
                    } else {
                        $scope.setPropertyInfo();
                        if ($rootScope.isDev == false) {
                            if ($scope.propertyInfo.coords !== null) {
                                $scope.setPoly();
                            }
                            //$scope.marker.setIcon('https://chart.apis.google.com/chart?chst=d_map_pin_letter&chld=%E2%80%A2|47c9af');
                            $scope.marker.setIcon($scope.prop_icon);
                            $scope.marker.setPosition(event.latLng);

                            if ($scope.initProp == 0) {
                                $scope.layersOff();
                            }

                            $scope.polyTriangle.setOptions($scope.polygonOptions);

                            $scope.marker.setPosition(event.latLng);

                            if (!$scope.propClick)
                                $scope.propClick = true;

                            if ($scope.initProp == 0) {
                                if ($rootScope.currentUser.acc_type == "GUEST") {
                                    $scope.categoryLayer('official-plan');
                                    $scope.getSidebar('prime_sidebar');

                                } else {
                                    $scope.categoryLayer('official-plan');
                                    if (($rootScope.initSidebar && !$scope.onSidebar) || $location.search().address) {
                                        /*var sideID = angular.element( document.querySelector( '#catSide' ) );
                                        sideID.removeClass('no-sidebar');
                                        if(!sideID.hasClass('no-sidebar')){
                                            sideID.addClass('sidebar');
                                        }*/
                                        $scope.getSidebar('officialplan_sidebar');
                                        //sideID.toggleClass('sidebar');
                                    }
                                }
                                $scope.initProp++;
                            } else {

                                var layer = $location.path().replace('/', '');
                                $scope.categoryLayer(layer);
                                layer = layer.replace('-', '');
                                layer = layer + '_sidebar';
                                if (layer == "provincialplan_sidebar")
                                    layer = "provincial_sidebar";
                                if (!$scope.onSidebar)
                                    $scope.onSidebar = true;
                                $scope.getSidebar(layer);
                            }

                            $scope.tutorialCount(2);

                            $rootScope.$broadcast('openSidebar');

                            $scope.addressWindow.open($scope.map, $scope.marker);
                            //$scope.addressBox.open($scope.map,$scope.marker);
                            $scope.polyTriangle.setMap($scope.map);
                            $scope.map.setCenter($scope.marker.getPosition());
                            $scope.map.panBy(-250, 0);

                            $rootScope.lng4326 = $scope.polyTriangle.my_getBounds().getCenter().lng();
                            $rootScope.lat4326 = $scope.polyTriangle.my_getBounds().getCenter().lat();

                            // EPSG:900913 (OpenStreetMap conversion)
                            var coord = proj4('EPSG:4326', 'EPSG:900913', [$rootScope.lng4326, $rootScope.lat4326]);
                            $rootScope.lng = coord[0];
                            $rootScope.lat = coord[1];
                            $rootScope.$broadcast('sidebar/report/updatereportcoordinates', [$rootScope.lat, $rootScope.lng]);

                            // EPSG:2952 (Ontario conversion)
                            var coord_ontario = proj4('EPSG:4326', '+proj=tmerc +lat_0=0 +lon_0=-79.5 +k=0.9999 +x_0=304800 +y_0=0 +ellps=clrk66 +units=m +no_defs', [$rootScope.lng4326, $rootScope.lat4326]);
                            $rootScope.lng2019 = coord_ontario[0];
                            $rootScope.lat2019 = coord_ontario[1];
                        }
                    }

                    break;
            }
        }
    };

    //Function for animation
    $scope.checkSearch = function () {
        if (!$scope.canToggle && !$scope.propClick) {
            $scope.showMsg = true;
            $scope.message = "Please search an address and select a property before turning on layers.";
            $timeout(function () {
                $scope.showMsg = false;
            }, 5000);
        } else if ($scope.canToggle && !$scope.propClick) {
            $scope.showMsg = true;
            $scope.message = "Please select a property before viewing the sidebar.";

            $timeout(function () {
                $scope.showMsg = false;
            }, 5000);
        }
    };

    //Function to launch login dialog for user
    $scope.showLogin = function () {
        ngDialog.closeAll();
        if ($rootScope.userAgent.indexOf('Mobile') != -1) {
            ngDialog.open({
                templateUrl: 'templates/mobile-login-warning.tpl.html',
                className: 'ngdialog-theme-plain',
                closeByEscape: false,
                closeByDocument: false,
                showClose: false
            });
        } else {
            $scope.loginDialog = ngDialog.open({
                templateUrl: 'templates/login.tpl.html',
                controller: 'loginCtrl',
                className: 'ngdialog-theme-plain'
            });
            $scope.loginDialog.closePromise.then(function (data) {
                if ($location.path() == '/prime')
                    $location.path($scope.userPath);
            });
        }
    };

    //Function to launch signup dialog for user
    $scope.showSignup = function () {
        ngDialog.closeAll();
        $scope.signupDialog = ngDialog.open({
            templateUrl:'templates/tmp_register.tpl.html',
            controller:'registerCtrl',
            className: 'ngdialog-theme-plain'
        });
    };

    //Function to launch success login dialog for user
    $scope.showSuccess = function () {
        $scope.loginDialog = ngDialog.open({
            templateUrl: 'templates/login-success.tpl.html',
            controller: 'loginCtrl',
            className: 'ngdialog-theme-plain'
        });
        $scope.loginDialog.closePromise.then(function (data) {
            if ($location.path() == '/prime')
                $location.path($rootScope.userPath);
            else {
                window.location.href = 'https://' + $location.host();
            }
        });
    };

    //Function to launch success activated dialog for user
    $scope.showActivated = function () {
        if ($rootScope.userAgent.indexOf('Mobile') != -1) {
            ngDialog.open({
                template: '/templates/activation-mobile.tpl.html',
                controller: 'Tut1Ctrl',
                className: 'tutorial-theme',
                closeByEscape: false,
                closeByDocument: false,
                showClose: false
            });
        } else {
            $scope.loginDialog = ngDialog.open({
                templateUrl: 'templates/activated-success.tpl.html',
                controller: 'loginCtrl',
                className: 'ngdialog-theme-plain'
            });
            $scope.loginDialog.closePromise.then(function (data) {
                if ($location.path() == '/prime')
                    $location.path($rootScope.userPath);
                else {
                    window.location.href = 'https://' + $location.host();
                }
            });
        }

        EventsLoggingService.activated(EventTypes.ACTIVATED_SUCCESS);
    };

    //Function to launch search dialog for user that hasn't performed an initial search
    $scope.launchSearch = function () {
        var dialog = ngDialog.open({
            templateUrl: '/templates/search-console.html',
            className: 'ngdialog-theme-default search'
        });
        dialog.closePromise.then(function (data) {

        });
    };

    //Function to launch Contact Us dialog
    $scope.openContact = function () {
        var dialog = ngDialog.open({
            templateUrl: 'templates/contact-console.html',
            controller: 'ContactCtrl',
            className: 'ngdialog-theme-default'
        });
    };

    //Function to open Report Maker Dialog
    $scope.openReport = function () {
        $rootScope.$broadcast('sidebar/report/openreport');
    };

    //Function to open Report Maker Dialog
    $scope.devReport = function () {
        $rootScope.userPath = $location.path();
        //Close the sidebar if it's open
        $rootScope.$broadcast('closeSidebar');
        $location.path('/report');
    };

    //Obtain legend information
    $scope.setLegend = function (info, title) {
        $scope.legendInfo = info;
        $scope.legendTitle = title;
    };

    $scope.showTutorial = function () {
        EventsLoggingService.clickedTutorial(EventTypes.CLICKED_SHOW_TUTORIAL);
        ngDialog.open({
            template: '/templates/tutorial2.tpl.html',
            controller: 'Tut1Ctrl',
            className: 'tutorial-theme'
        });
    };

    /*** Auth Function ***/
    //Used to log user out of there account
    $scope.logout = function () {
        $scope.userPath = $location.path();
        authenticationService.logout().success(function (data) {
            $rootScope.currentUser = data.flash;
            $scope.$broadcast(AUTH_EVENTS.logoutSuccess);
        });//call logout service
    };

    /*** History Function ***/
    //Used to store history into table
    $scope.savehistory = function () {
        historyService.savehistory($scope.history).success(function (data) {
        });
    };

    /*** Sidebar Functions ***/
    //Used to populate sidbar based on property clicked by the user
    $scope.getSidebar = function (type) {
        console.log('sidebar called');
        //Clear the sidebar every time a new request for information comes in
        $scope.clearSidebar();
        if ($scope.isInteger($scope.sidebar.gid) && $rootScope.isPropertySelected == true) {
            $scope.sidebar.type = type;

            sidebarService.sidebarInfo($scope.sidebar).success(function (data) {
                if ($scope.sidebar.type == "water_sidebar") {
                    $rootScope.$broadcast('sidebar/water/update', data);
                } else if ($scope.sidebar.type == "provincial_sidebar") {
                    $rootScope.$broadcast('sidebar/provincial/update', data);
                } else if ($scope.sidebar.type == "environment_sidebar") {//Check for environment type
                    $rootScope.$broadcast('sidebar/environ/update', data);
                } else if ($scope.sidebar.type == "officialplan_sidebar") {
                    $rootScope.$broadcast('sidebar/official/update', data);
                } else if ($scope.sidebar.type == "bylaw_sidebar") {
                    $rootScope.$broadcast('sidebar/bylaw/update', data);
                } else if ($scope.sidebar.type == "opcitywide-toronto_sidebar") {
                    $rootScope.$broadcast('sidebar/citywide/update', data);
                } else if ($scope.sidebar.type == "devapp_sidebar") {
                    $rootScope.$broadcast('sidebar/devapp/update', data);
                }
            }).error(function (data) {

            });
        }
    };

    //Check if value is an integer or not
    $scope.isInteger = function (number) {
        return number % 1 === 0;
    };

    //Event to trigger sidebar call
    $rootScope.$on('getSidebar', function (event) {
        $scope.categoryLayer('official-plan');
        $scope.getSidebar('officialplan_sidebar');
    });

    //Clear sidebar function
    $scope.clearSidebar = function () {
        //Show default message in sidebar
        var resetScopeData = function () {
            $rootScope.$broadcast('sidebar/water/reset');
            $rootScope.$broadcast('sidebar/provincial/reset');
            $rootScope.$broadcast('sidebar/environ/reset');
            $rootScope.$broadcast('sidebar/official/reset');
            $rootScope.$broadcast('sidebar/bylaw/reset');
            $rootScope.$broadcast('sidebar/citywide/reset')
        };

        $scope.$evalAsync(resetScopeData);
    };

    /*** Auth functions ***/
    $rootScope.userStatus = function () {
        var connected = authenticationService.isLogged();//Checks if user is logged in via cookie
        connected.then(function (msg) {
            if (msg.data) {
                return true;
            } else {
                return false;
            }
        });
    };

    if (sessionStorage.getItem("azureWarning")) {
        $scope.isAzureWarning = true;
    }

    /*** Cookie functions ***/
    $scope.warningCheck = function () {
        if (!sessionStorage.getItem("azureWarning")) {
            sessionStorage.setItem("azureWarning", 1);
        }
    };

    $scope.tutorialCount = function (page) {
        //If Mobile or Tablet show under development message
        if ($rootScope.userAgent.indexOf('Mobile') != -1) {
            ngDialog.open({
                template: '/templates/mobile-warning.tpl.html',
                controller: 'Tut1Ctrl',
                className: 'tutorial-theme',
                closeByEscape: false,
                closeByDocument: false,
                showClose: false
            });
        } else {

            if (page == 1) {

                //If Mobile or Tablet show under development message
                if ($rootScope.userAgent.indexOf('Mobile') != -1) {
                    ngDialog.open({
                        template: '/templates/mobile-warning.tpl.html',
                        controller: 'Tut1Ctrl',
                        className: 'tutorial-theme'
                    });
                }

                if ($rootScope.userAgent.indexOf('Mobile') == -1) {
                    //Call Tutorial1 Cookie
                    authenticationService.tutorial1().success(function (data) {
                        $scope.tut1 = data;
                        if ($scope.tut1 < 2) {
                            ngDialog.open({
                                template: '/templates/tutorial2.tpl.html',
                                controller: 'Tut1Ctrl',
                                className: 'tutorial-theme'
                            });
                        }
                    });
                }

            } else if (page == 2) {
                if ($rootScope.userAgent.indexOf('Mobile') == -1) {
                    //Call Tutorial2 Cookie
                    authenticationService.tutorial2().success(function (data) {
                        $scope.tut2 = data;
                        if ($scope.tut2 < 2) {
                            ngDialog.open({
                                template: '/templates/tutorial3.tpl.html',
                                controller: 'Tut3Ctrl',
                                className: 'tutorial-theme'
                            });
                        }
                    });
                }
            }
        }
    };

    /**** End of functions ****/

    if ($location.absUrl().indexOf('login') != -1) {
        $scope.userPath = '/login';
    }

    if ($location.absUrl().indexOf('signup') != -1) {
        $scope.userPath = '/signup';
    }

    if ($location.absUrl().indexOf('success') != -1) {
        $scope.userPath = '/success';
    }

    if ($location.absUrl().indexOf('activated') != -1) {
        $scope.userPath = '/activated';
    }

    if ($location.path() == '/tutorial1') {
        $scope.userPath = '/tutorial1';
    }

    if ($location.path() == '/resetpassword') {
        $scope.userPath = '/resetpassword';
    }

    if ($scope.initSearch) {
        if ($location.search().address && $location.search().lat && $location.search().lng) {
            $scope.setLocationwithURL();
        }
        $scope.tutorialCount(1);

        if ($location.path() == '/dev-app-toronto') {
            $location.path('/official-plan');
        }
    }
    else if (!$scope.initSearch && $location.path('/')) {

        if ($scope.userPath == '/tutorial1') {
            ngDialog.open({
                template: '/templates/tutorial2.tpl.html',
                controller: 'Tut1Ctrl',
                className: 'tutorial-theme'
            });
        } else if ($scope.userPath == '/resetpassword') {
            $scope.resetDialog = ngDialog.open({
                templateUrl: 'templates/reset.tpl.html',
                controller: 'ResetCtrl',
                className: 'ngdialog-theme-plain'
            });
            $scope.resetDialog.closePromise.then(function (data) {
                $scope.userPath = '/';
                $location.path('/login');
            });
        } else if ($scope.userPath == '/login') {
            var connected = authenticationService.isLogged();//Checks if user is logged in via cookie
            connected.then(function (msg) {
                if (msg.data) {
                    $scope.launchSearch();
                } else {
                    $scope.showLogin();
                }
            });
        } else if ($scope.userPath == '/signup') {
            var connected = authenticationService.isLogged();//Checks if user is logged in via cookie
            connected.then(function (msg) {
                if (msg.data) {
                    $scope.launchSearch();
                } else {
                    $scope.showSignup();
                }
            });
        } else if ($scope.userPath == '/success') {
            var connected = authenticationService.isLogged();//Checks if user is logged in via cookie
            connected.then(function (msg) {
                if (msg.data) {

                } else {
                    $scope.showSuccess();
                }
            });
        } else if ($scope.userPath == '/activated') {
            var connected = authenticationService.isLogged();//Checks if user is logged in via cookie
            connected.then(function (msg) {
                if (msg.data) {

                } else {
                    $scope.showActivated();
                }
            });
        } else {
            $scope.launchSearch();
        }
    }

    $scope.recenterMap = (paramPosition) => {
        console.log('4 - recenterMap');
        const position = paramPosition || $scope.addressWindow.getPosition();
        $scope.map.setCenter(position);//Re center the the map to take the dev app window into account
        $scope.map.panBy(-250, 0);//Pan the map so that the dev app window comes into clear view for the user
    };

    $scope.reload = () => {
        document.location.reload(true);
        top.location.href = top.location.href.split('#')[0]
    };

    $scope.isLoggedIn = () => {
        return $scope.isUser;
    }

    const openAddressWindow = (position, hideMarker) => {
        console.log('3 - openAddressWindow');
        if (position) {
            $scope.addressWindow.setPosition(position);
        }

        if (hideMarker) {
            $scope.addressWindow.open($scope.map);
        } else {
            $scope.addressWindow.open($scope.map, $scope.marker);
        }
    };

    const setAddressWindowContent = (content) => {
        console.log('2 - setaddresswindowcontent');
        $scope.addressWindow.setContent(content);
    };

    $rootScope.$on('map/openaddresswindow', getHandlerFor(openAddressWindow));
    $rootScope.$on('map/setaddresswindowcontent', getHandlerFor(setAddressWindowContent));
    $rootScope.$on('map/recenter', getHandlerFor($scope.recenterMap));
    $rootScope.$on('map/setinfocontent', getHandlerFor($scope.setInfoContent));
    $rootScope.$on('map/setlegend', getHandlerFor($scope.setLegend));

    return {
        openAddressWindow
    };
};



// WEBPACK FOOTER //
// ./client/controllers/MapLoad.js